<div class="alert-box">
    <div class="modal-header">
        <button type="button" class="close" aria-label="Close" (click)="onCancel()">
            <span aria-hidden="true">&times;</span>
        </button>
        <h4 class="modal-title">{{ "save_confirm_modal_header_title" | translate }}</h4>
    </div>
    <div class="modal-body">
        <p class="mb-20">{{ "save_confirm_modal_body_text" | translate }}</p>

        <div class="alert alert-warning">
            <div *ngFor="let errorItem of errors">
                <span>{{ errorItem.label | translate }}</span>
                <ul>
                    <li *ngFor="let error of errorItem.errors">
                        {{ error.key | translate: error?.params }}
                    </li>
                </ul>
            </div>
        </div>
    </div>

    <div class="modal-footer">
        <button type="button" class="btn btn-default" (click)="onCancel()">
            {{ "save_confirm_modal_action_cancel" | translate }}
        </button>
        <button type="button" class="btn btn-primary" (click)="onConfirm()">
            {{ getConfirmButtonTranslations | translate }}
        </button>
    </div>
</div>
